import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import { COLOR_PRIMARY_2 } from 'src/colors';
import { getTokenThunk } from 'src/store/Auth/actions';
import { getheadertext, handleSubscriptionModalOpen } from '../../helper';
import TooltipNew from 'src/App/HOC/Tooltips/TooltipNew';
import { getSubscriptionPlanToUpgrade } from 'src/utils/functions';
import { useSetUserPaymentInterest } from 'src/hooks/useCustomHooks';

const SubscriptionPlanChip = ({
  dashboardState,
  setSubscriptionModalOpen,
  address,
  centerCoord,
  setLoginModalOpen,
  isRenderedInOption,
}) => {
  const user = useSelector(state => (state as any).dashboard.user);
  const [showCredits, setShowCredits] = useState(false);
  const isLoggedIn = getTokenThunk()();

  const { triggerPaymentInterest } = useSetUserPaymentInterest();

  let userName = user && user.userName;
  if (!userName) {
    userName = 'Trial';
  }

  const getTooltipText = () => {
    const currentPlan = user.subscriptionPlan;
    if (currentPlan === 'scale') {
      return <></>;
    }
    const nextPlanToUpgrade = getSubscriptionPlanToUpgrade(currentPlan)
    return (
      <>
        You’re on <span style={{ textTransform: 'capitalize' }}>{currentPlan}</span> Plan.
        Upgrade to <span style={{ textTransform: 'capitalize' }}>{nextPlanToUpgrade}</span>.
      </>
    );
  };

  useEffect(() => {
    if (user.credits > 0 || user.estimatorCredits > 0 || user.subscriptionPlan !== 'starter') {
      setShowCredits(true);
    }
  }, [user]);

  if (user.subscriptionPlan === 'scale') {
    return <></>;
  }

  return (
    <>
      <TooltipNew title={getTooltipText()} minWidth={320} content={''}>
        <Typography
          variant="body1"
          onClick={() => {
              triggerPaymentInterest();
              handleSubscriptionModalOpen(
                isLoggedIn,
                centerCoord,
                address,
                setLoginModalOpen,
                setSubscriptionModalOpen
              );              
            }
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            color: COLOR_PRIMARY_2,
            fontWeight: 'bold',
            textTransform: 'capitalize',
            cursor: 'pointer',
            marginLeft: '2px',
            marginRight: '6px',
            border: '1px solid ' + COLOR_PRIMARY_2,
            padding: '5px 10px',
            borderRadius: '8px',
          }}
        >
          {getheadertext(dashboardState, user, showCredits)}
        </Typography>
      </TooltipNew>
    </>
  );
};

export default SubscriptionPlanChip;
